import { ComboDataDTO } from "../../dto/ComboDataDTO";
import { axiosInstance } from "../../App";


export function getProfessionalsAllowedToBeAssignToHomeHospitalization(inputText:string,offSet:number,pageSize:number){
    return axiosInstance.get('/api/secured/homehospitalization/getProfessionalsAllowedToBeAssignToHomeHospitalization',{
        params: {
            offSet,
            pageSize,
            inputText,
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getHospitalizedPatients(inputText:string,offSet:number,pageSize:number){
    return axiosInstance.get('/api/secured/homehospitalization/getHospitalizedPatients',{
        params: {
            offSet,
            pageSize,
            inputText,
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getPatientsWithHomeHospitalizationAttentions(inputText: string, offSet: number, pageSize: number){
    return axiosInstance.get(
        '/api/secured/homehospitalization/getPatientsWithHomeHospitalizationAttentions',
        {
        params: {
            offSet,
            pageSize,
            inputText,
        }
        }
    ).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
    }


export function getAttentionStates(){
    return axiosInstance.get('/api/secured/homehospitalization/getAttentionStates',{}).then((response) => {return response.data;})
    .catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getShowProfessionals(){
    return axiosInstance.get('/api/secured/homehospitalization/getShowProfessionals',{}).then((response) => {return response.data;})
    .catch((error) => {
        console.error(error);
        throw error;
    });
}

export async function getCanAuditHomeHospitalization() {
  return axiosInstance.get('/api/secured/homehospitalization/getCanAuditHomeHospitalization')
    .then(r => r.data)
    .catch((error) => {
        console.error(error)
        throw error
    });
}

export function loadProfessionalAttentionLogDetail(professionalAttentionLog:bigint){
    return axiosInstance.get('/api/secured/homehospitalization/loadProfessionalAttentionLogDetail',{
        params: {
            professionalAttentionLog:professionalAttentionLog
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function loadExternalDataGridForHomeHospitalizationReport(params:any){
    return axiosInstance.post('/api/secured/homehospitalization/loadExternalDataGridForHomeHospitalizationReport',{
        from: params.from?params.from.toISOString():null,
        to: params.to?params.to.toISOString():null,
        professional: params.professional?.id,
        patient: params.patient?.id,
        attentionState:params.state?.id
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function loadProfessionalAttentionLogForView (offset:number, pageSize:number, params:any){
    return axiosInstance.post('/api/secured/homehospitalization/loadProfessionalAttentionLogForView',{
        loadConfigDTO:{
            offSet:offset,
            pageSize,
            filters: params.filterDTO,
            sortingFieldInfoList: params.multiSortMeta
        },
        from: params.from?params.from.toISOString():null,
        to: params.to?params.to.toISOString():null,
        professional: params.professional?.id,
        patient: params.patient?.id,
        attentionState:params.state ?? 0,
        auditState: params.auditState ?? 0
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
    })
}

export function loadProfessionalAttentionLogForViewHistorical (offset:number, pageSize:number, params:any){
    return axiosInstance.post('/api/secured/homehospitalization/loadProfessionalAttentionLogForViewHistorical',{
        loadConfigDTO:{
            offSet:offset,
            pageSize,
            filters: params.filterDTO,
            sortingFieldInfoList: params.multiSortMeta
        },
        from: params.from?params.from.toISOString():null,
        to: params.to?params.to.toISOString():null,
        professional: params.professional?.id,
        patient: params.patient?.id,
        attentionState:params.state ?? 0,
        auditState: params.auditState ?? 0
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
    })
}

export function getProfessionalAttentionLogDetailReport({from, to, professional, patient, state}: { from: Date, to: Date, professional: any, patient: any, state: number}) {
    return axiosInstance.get('/api/secured/homehospitalization/getProfessionalAttentionLogDetailReport', {
        params: {
            from: from ? from.toISOString() : null,
            to: to ? to.toISOString() : null,
            professional: professional?.id,
            patient: patient?.id,
            state
        },
        responseType: 'blob' 
    }).then(response => {
        const blob = new Blob([response.data], { 
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Reporte_de_atención.xlsx";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }, 0);
    }).catch(error => {
        console.error('Error al descargar el excel:', error);
        throw error;
    });
}

export function findHHMapReport(from: Date, to:Date, professional:ComboDataDTO, patient:ComboDataDTO, state:number) {
    return axiosInstance.get('/api/secured/homehospitalization/findHHMapReport', {
        params: {
            from: from ? from.toISOString() : null,
            to: to ? to.toISOString() : null,
            professional: professional?.id,
            patient: patient?.id,
            attentionState:state
        }
    })
    
}

export function getAuditStates() {
  return axiosInstance
    .get('/api/secured/homehospitalization/getAuditStates')
    .then((response) => response.data)
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateAuditState(professionalAttentionLogId, auditStateId, observations) {
  return axiosInstance.post(`/api/secured/homehospitalization/updateAuditState`, null, {
    params: {
      professionalAttentionLogId,
      auditStateId,
      observations
    }
  });
}

export async function approveAttention(professionalAttentionLogId: number) {
  return axiosInstance.post(`/api/secured/homehospitalization/approveAttention`, null, {
    params: {
      professionalAttentionLogId
    }
  }).then((response) => response.data)
  .catch((error) => {
    console.error(error);
    throw error;
  });
}

export async function updateAttentionPractices(professionalAttentionLogId: number, practices: any[]) {
  return axiosInstance.post(`/api/secured/homehospitalization/updateAttentionPractices`, practices, { 
    params: { 
        professionalAttentionLogId 
    } 
  })
  .then((response) => response.data)
  .catch((error) => {
    console.error(error)
    throw error
  })
}

export function useHomeHospitalizationService() {
  return {
    getProfessionalsAllowedToBeAssignToHomeHospitalization,
    getHospitalizedPatients,
    getPatientsWithHomeHospitalizationAttentions,
    getAttentionStates,
    getShowProfessionals,
    getCanAuditHomeHospitalization,
    loadProfessionalAttentionLogDetail,
    loadExternalDataGridForHomeHospitalizationReport,
    loadProfessionalAttentionLogForView,
    loadProfessionalAttentionLogForViewHistorical,
    getProfessionalAttentionLogDetailReport,
    findHHMapReport,
    getAuditStates,
    updateAuditState,
    approveAttention,
    updateAttentionPractices,
  }
}
